var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// - Import react components
import { push } from 'react-router-redux';
// -Import domain
import { User } from 'src/core/domain/users';
// - Import action types
import { AuthorizeActionType } from 'constants/authorizeActionType';
// - Import actions
import * as globalActions from 'store/actions/globalActions';
import { provider } from 'src/socialEngine';
import { SocialProviderTypes } from 'src/core/socialProviderTypes';
/* _____________ CRUD State _____________ */
/**
 * Loing user
 * @param {string} uids
 */
export var login = function (uid, isVerifide) {
    return {
        type: AuthorizeActionType.LOGIN,
        payload: { authed: true, isVerifide: isVerifide, uid: uid }
    };
};
/**
 * Logout user
 */
export var logout = function () {
    return { type: AuthorizeActionType.LOGOUT };
};
/**
 * User registeration call
 * @param user  for registering
 */
export var signup = function (user) {
    return {
        type: AuthorizeActionType.SIGNUP,
        payload: __assign({}, user)
    };
};
/**
 * Update user's password
 */
export var updatePassword = function () {
    return { type: AuthorizeActionType.UPDATE_PASSWORD };
};
/**
 * Get service providers
 */
var authorizeService = provider.get(SocialProviderTypes.AuthorizeService);
/* _____________ CRUD DB _____________ */
/**
 * Log in user in server
 */
export var dbLogin = function (email, password) {
    return function (dispatch, getState) {
        dispatch(globalActions.showNotificationRequest());
        return authorizeService.login(email, password).then(function (result) {
            dispatch(globalActions.showNotificationSuccess());
            dispatch(login(result.uid, result.emailVerified));
            dispatch(push('/'));
        }, function (error) { return dispatch(globalActions.showMessage(error.code)); });
    };
};
/**
 * Log out user in server
 */
export var dbLogout = function () {
    return function (dispatch, getState) {
        return authorizeService.logout().then(function (result) {
            dispatch(logout());
            dispatch(push('/login'));
        }, function (error) { return dispatch(globalActions.showMessage(error.code)); });
    };
};
/**
 * Send email verification
 */
export var dbSendEmailVerfication = function () {
    return function (dispatch, getState) {
        dispatch(globalActions.showNotificationRequest());
        return authorizeService.sendEmailVerification().then(function () {
            // Send email verification successful.
            dispatch(globalActions.showNotificationSuccess());
            dispatch(push('/'));
        })
            .catch(function (error) {
            // An error happened.
            dispatch(globalActions.showMessage(error.code));
        });
    };
};
/**
 *
 * @param user for registering
 */
export var dbSignup = function (user) {
    return function (dispatch, getState) {
        dispatch(globalActions.showNotificationRequest());
        var newUser = new User();
        newUser.email = user.email;
        newUser.password = user.password;
        newUser.fullName = user.fullName;
        return authorizeService.registerUser(newUser).then(function (result) {
            dispatch(signup(__assign({ userId: result.uid }, user)));
            dispatch(dbSendEmailVerfication());
            dispatch(push('/emailVerification'));
        })
            .catch(function (error) { return dispatch(globalActions.showMessage(error.code)); });
    };
};
/**
 * Change user's password
 * @param {string} newPassword
 */
export var dbUpdatePassword = function (newPassword) {
    return function (dispatch, getState) {
        dispatch(globalActions.showNotificationRequest());
        return authorizeService.updatePassword(newPassword).then(function () {
            // Update successful.
            dispatch(globalActions.showNotificationSuccess());
            dispatch(updatePassword());
            dispatch(push('/'));
        })
            .catch(function (error) {
            // An error happened.
            switch (error.code) {
                case 'auth/requires-recent-login':
                    dispatch(globalActions.showMessage(error.code));
                    dispatch(dbLogout());
                    break;
                default:
            }
        });
    };
};
/**
 * Reset user's password
 * @param {string} newPassword
 */
export var dbResetPassword = function (email) {
    return function (dispatch, getState) {
        dispatch(globalActions.showNotificationRequest());
        return authorizeService.resetPassword(email).then(function () {
            // Reset password successful.
            dispatch(globalActions.showNotificationSuccess());
            dispatch(push('/login'));
        })
            .catch(function (error) {
            // An error happened.
            dispatch(globalActions.showMessage(error.code));
        });
    };
};
/**
 * Login user with OAuth
 */
export var dbLoginWithOAuth = function (type) {
    return function (dispatch, getState) {
        dispatch(globalActions.showNotificationRequest());
        return authorizeService.loginWithOAuth(type).then(function (result) {
            // Send email verification successful.
            dispatch(globalActions.showNotificationSuccess());
            dispatch(login(result.uid, true));
            dispatch(push('/'));
        })
            .catch(function (error) {
            // An error happened.
            dispatch(globalActions.showMessage(error.code));
        });
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/authorizeActions.ts
// module id = 402
// module chunks = 50